import { configureTextBuilder } from 'troika-three-text';

let configured = false;

/**
 * Configures how troika texts are built, for the whole page: troika keeps the configuration from
 * before its first text, so every page that shows texts calls this first.
 *
 * The texts are laid out in a web worker, since laying out thousands of texts, e.g. of a drawing
 * or the height labels of an asset, blocks the page for seconds on the main thread.
 */
export function configureTexts() {
  if (configured) {
    return;
  }

  configured = true;
  configureTextBuilder({
    useWorker: true,
    defaultFontURL: '/static/fonts/truetype/Inter_24pt-Regular.ttf',
    sdfGlyphSize: 32,
  });
}
